import { EventBus } from "OK/EventBus";

export const LayersEventBusesPrefix = 'layers';

const create = EventBus.factory(LayersEventBusesPrefix);

export interface ILayerCloseEvent {
    layerId: string
}

export const ANY_OPENED = create<void>('anyOpened');

export const ANY_CLOSED = create<void>('anyClosed');

export const MODAL_CLOSE = create<ILayerCloseEvent>('modalClose');

export const MODAL_LOADER_SHOW = create<null>('modalLoaderShow');

export interface ILayerLoaderHideEvent {
    forceHide?: boolean;
}
export const MODAL_LOADER_HIDE = create<ILayerLoaderHideEvent>('modalLoaderHide');
